import React, { useState } from "react";
import SettingsTab from "../SettingsTab";
import { Spinner, Alert, Callout, Intent, Button } from "@blueprintjs/core";
import styles from "./BillingInformationSettings.module.scss";
import { Toolbar } from "../../../molecules/Toolbar";
import SettingsForm from "../SettingsForm";
import FormSection from "../../../atoms/FormSection/FormSection";
import FormHeading from "../../../atoms/FormHeading/FormHeading";
import { PaymentSidebar } from "../../../molecules/PaymentSidebar";
import { useBillingInfoDetails } from "./hook";
import { HTMLSelect as Select } from "@blueprintjs/core/lib/esm/components/html-select/htmlSelect";
import { Icon } from "../../../atoms/Icon";
import { InvoiceList } from "./InvoiceList";
import { CurrentBillingPackage } from "./CurrentBillingPackage";
import { BillingCardInfo } from "./BillingCardInfo";

export default function BillingInformationSettings() {
  const {
    balance,
    paymentMethod,
    subscription,
    currentSubscriptionPlan,
    changePlan,
    subscriptionList,
    setChangePlan,
    isAlertOpen,
    setIsAlertOpen,
    customerInvoices,
    fixedFee,
    variableFee,
    loading,
    error,
    isValid,
    onConfirmSubscription,
    pageIsLoading,
    onChangeSubscription,
    alertMessage
  } = useBillingInfoDetails();

  const [isPaymentSidebarOpen, setIsPaymentSidebarOpen] = useState(false);
  const onDismiss = () => {
    setIsPaymentSidebarOpen(false);
  };

  if (pageIsLoading) {
    return (
      <SettingsTab centered>
        <Spinner />
      </SettingsTab>
    );
  }
  return (
    <SettingsTab>
      <Alert
        className={styles.subscriptionAlert}
        intent="primary"
        icon={<Icon name="warning-sign" color="#7a869b" size={32} />}
        isOpen={isAlertOpen}
        canEscapeKeyCancel
        canOutsideClickCancel
      >
        <p>{alertMessage}</p>
        {isValid.state && (
          <Button
            style={{ marginLeft: "10px", float: "right" }}
            intent={Intent.PRIMARY}
            onClick={() => onConfirmSubscription()}
          >
            {loading ? (
              <div>
                <Spinner intent={Intent.WARNING} size={13} />
              </div>
            ) : (
              <div>Save</div>
            )}
          </Button>
        )}

        <Button
          style={{ float: "right" }}
          onClick={() => {
            setIsAlertOpen(false);
          }}
        >
          Cancel
        </Button>
      </Alert>

      <PaymentSidebar
        sidebarIsOpen={isPaymentSidebarOpen}
        onDismiss={onDismiss}
      />

      <Toolbar title="Settings" />
      <SettingsForm>
        <FormHeading weight="600" size={16}>
          Billing Information
        </FormHeading>

        <FormSection className={styles.currentPackage}>
          <CurrentBillingPackage
            subscriptionPlan={currentSubscriptionPlan}
            currentPeriodEnd={subscription.currentPeriodEnd}
            isTrial={subscription.status === "Trialing"}
            fixedFee={fixedFee}
            variableFee={variableFee}
            changePlan={changePlan}
            setChangePlan={setChangePlan}
          />

          {changePlan && (
            <div>
              <div className={styles.row}>
                <div className={styles.headingHolder}>
                  <FormHeading className={styles.heading} weight="600">
                    Change Plan
                  </FormHeading>
                </div>
              </div>
              <Select
                options={subscriptionList}
                value={currentSubscriptionPlan.id}
                onChange={(e) => onChangeSubscription(e.target.value)}
                className={styles.changePlanDropDown}
              />
            </div>
          )}

          {error && (
            <Callout
              intent={Intent.DANGER}
              title={error.title}
              style={{ marginBottom: "1em", marginTop: "1em" }}
              icon="error"
            >
              {error.message}
            </Callout>
          )}

          <BillingCardInfo
            paymentMethod={paymentMethod}
            setIsPaymentSidebarOpen={setIsPaymentSidebarOpen}
          />

          <InvoiceList invoices={customerInvoices} balance={balance} />
        </FormSection>
      </SettingsForm>
    </SettingsTab>
  );
}
